var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 293,
    viewBox: "0 0 293 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.481 31.7165C157.986 16.1793 175.205 8.23151 189.952 14.8821C205.34 21.8215 210.452 41.1561 200.504 54.7937L155.876 115.978C152.187 121.035 145.469 122.83 139.75 120.288C133.682 117.592 130.538 110.829 132.388 104.451L153.481 31.7165Z",
    fill: "#29ABAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0065 103.819C20.6053 94.7571 18.3325 75.929 29.1924 63.9387C40.524 51.4276 60.494 52.5037 70.4156 66.1601L114.928 127.429C118.607 132.493 118.252 139.437 114.075 144.099C109.645 149.045 102.243 149.959 96.7422 146.239L34.0065 103.819Z",
    fill: "#29ABAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2555 238.314C53.2885 247.987 34.7612 243.937 27.0125 229.736C18.9273 214.919 26.5153 196.415 42.6761 191.54L115.181 169.67C121.173 167.862 127.614 170.483 130.642 175.961C133.854 181.772 132.281 189.063 126.959 193.033L66.2555 238.314Z",
    fill: "#29ABAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.84 120.844C276.016 120.655 288.612 134.833 286.519 150.875C284.335 167.613 267.31 178.107 251.376 172.537L179.886 147.548C173.977 145.482 170.312 139.573 171.088 133.362C171.912 126.774 177.474 121.805 184.113 121.728L259.84 120.844Z",
    fill: "#29ABAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.44 251.201C211.682 266.505 202.157 282.905 186.267 285.937C169.686 289.101 154.391 276.216 154.695 259.339L156.056 183.619C156.169 177.362 160.635 172.031 166.776 170.825C173.292 169.545 179.751 173.273 181.903 179.555L206.44 251.201Z",
    fill: "#29ABAC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.9,
    cy: 38.5389,
    r: 28.3246,
    fill: "#29ABAC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.059,
    cy: 81.5922,
    r: 28.3246,
    fill: "#29ABAC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.059,
    cy: 217.55,
    r: 28.3246,
    fill: "#29ABAC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.633,
    cy: 256.072,
    r: 28.3246,
    fill: "#29ABAC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3246,
    cy: 147.305,
    r: 28.3246,
    fill: "#29ABAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e3a4c214634508f5a8f5d01769d5019.svg";
export { ForwardRef as ReactComponent };